export default __webpack_public_path__ + "static/media/2_0018.cccbb215.webp";